import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Area } from '../shared/interfaces/area.interface';

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  constructor(private http: HttpClient) { }
  baseUrl = '@cec-api/area';


  get(): Promise <any>{
    return this.http.get(this.baseUrl).toPromise();
  }

  addArea(area: Area): Promise<any>{
    return this.http.post(this.baseUrl, area).toPromise();
  }

  getById(id: number):Promise<any>{
    return this.http.get(this.baseUrl+'/'+id).toPromise();
  }

  update(id: number, area: Area): Promise<any>{
    return this.http.put(this.baseUrl+'/'+id, area).toPromise();
  }

  delete(id:number): Promise<any>{
    return this.http.delete(this.baseUrl+'/'+id).toPromise();
  }

  searchArea(searchValue: string): Promise<any>{
    return this.http.get('@cec-api/area-search/?description='+searchValue).toPromise();
  }
}
